import { useParams, Navigate } from "react-router-dom";
import { orders } from "@/mocks/orders";
import OrderDetail from "@/pages/provider/orders/components/OrderDetail";

export default function OrderDetailPage() {
  const { id } = useParams<{ id: string }>();
  const order = orders.find((o) => o.id === id);

  if (!order) {
    return <Navigate to="/provider/orders" replace />;
  }

  return <OrderDetail order={order} />;
}